module.exports = __webpack_public_path__ + "static/img/tx_cqw.62f68e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/team/tx_cqw.png
// module id = ZPEk
// module chunks = 0